import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import format from 'date-fns/format';

import ArrowIcon from '@mui/icons-material/ArrowRightAlt';
import Box from '@mui/material/Box';

import { FlightSegments_segments$key } from '__generated__/FlightSegments_segments.graphql';

type Props = {
  segments: FlightSegments_segments$key;
};

const FlightSegments: FC<Props> = props => {
  const segments = useFragment(
    graphql`
      fragment FlightSegments_segments on FlightSegment @relay(plural: true) {
        id
        departDatetime
        departAirportCode
        arrivalDatetime
        arrivalAirportCode
      }
    `,
    props.segments
  );

  return (
    <Box>
      {segments.map(
        ({
          id,
          departDatetime,
          departAirportCode,
          arrivalDatetime,
          arrivalAirportCode,
        }) => (
          <Box key={id}>
            {format(new Date(departDatetime), 'HH:mm')} {departAirportCode}
            <ArrowIcon
              sx={{ display: 'inline-block', verticalAlign: 'middle' }}
            />
            {format(new Date(arrivalDatetime), 'HH:mm')} {arrivalAirportCode}
          </Box>
        )
      )}
    </Box>
  );
};

export default FlightSegments;
